import { useState, useEffect } from "react";
import { useDispatch } from 'react-redux'
import styled from "styled-components";
import { Form, DatePicker, Button, Select } from "antd";
import FromControl from "../../component/form/FormControl";

import MasterService from '../../service/_Master';
import Service from '../../service/mgt-sensor-data'
import Actions from '../../redux/actions'

import moment from "moment";
import "moment/locale/th";
moment.locale("th");

const { Option } = Select

const FormExtend = styled(FromControl)`
  height: 100%;
  border: 1px solid lightgray;
  border-radius: 5px;
  padding: 0px 20px;

  @media only screen and (max-width: 1024px){
    width: 50%;
  }

  @media only screen and (max-width: 768px){
    width: 50%
  }
  
  @media only screen and (max-width: 450px){
    width: 100%
  }

  @media only screen and (max-width: 376px){
    width: 100%
  }

  @media only screen and (min-width: 1200px){
    width: 50%
  }

  .form-button-radio{
    width: 100%;
  }

  .form-button.guild-date{
      display: flex;
      flex-direction: column;
  }
`

export default function FormSearch(props) {
  
  const [form] = Form.useForm();
  const dispatch = useDispatch()
  const [selStation, setSelStations] = useState([])
  const [selSensors, setSelSensors] = useState([])
  const [selParameters, setSelParameters] = useState([])

  useEffect(() => {
    form.setFieldsValue({
        from: moment(new Date()).set({hour: 0, minute: 0}),
        to: moment(new Date()).add(1, 'days').set({hour: 0, minute: 0}),
        stationId: 0, 
        sensorId: 0,
        parameterId: 0 
    });
    const initSel = async()=>{
      let stations = await MasterService.getMasterStationByOrgId();
      if(stations){
        setSelStations(stations)
      } 
    }
    
    const inti = async() =>{
      dispatch(Actions.MgtSensorData.setTblDataLoading(true))
      let formData= {
        from: moment(form.getFieldValue("from")).format("YYYY-MM-DD HH:mm"),
        to: moment(form.getFieldValue("to")).format("YYYY-MM-DD HH:mm"),
        stationId: form.getFieldValue("stationId") != 0 ? form.getFieldValue("stationId")  : null, 
        sensorId: form.getFieldValue("sensorId") != 0 ? form.getFieldValue("sensorId")  : null ,
        parameterId: form.getFieldValue("parameterId") != 0 ? form.getFieldValue("parameterId")  : null 
      }
      let data = await Service.search(formData)
      if(data){
        dispatch(Actions.MgtSensorData.setData(data))
        dispatch(Actions.MgtSensorData.setTblDataLoading(false))
      }
    }

    inti()
    initSel()
    const interval = setInterval(() => {
      inti()
    }, 1 * 1000 * 60);
    return () => {
      clearInterval(interval);
    }
  }, [form, dispatch]);

  const onFinish = async (values) => {
      dispatch(Actions.MgtSensorData.setTblDataLoading(true))
      let formData= {
      from: moment(form.getFieldValue("from")).format("YYYY-MM-DD HH:mm"),
      to: moment(form.getFieldValue("to")).format("YYYY-MM-DD HH:mm"),
      stationId: form.getFieldValue("stationId") != 0 ? form.getFieldValue("stationId")  : null, 
      sensorId: form.getFieldValue("sensorId") != 0 ? form.getFieldValue("sensorId")  : null ,
      parameterId: form.getFieldValue("parameterId") != 0 ? form.getFieldValue("parameterId")  : null 
    }
    let data = await Service.search(formData)
    if(data){
      dispatch(Actions.MgtSensorData.setData(data))
      dispatch(Actions.MgtSensorData.setTblDataLoading(false))
    }
  }

  const formInput = () => {
    return (
      <>
        <Form.Item
          name={["from"]}
          className="form-item__from"
          label="ค้นหาจากช่วงวันเวลา"
          rules={[{ required: true }]}
        >
          <DatePicker 
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item
          name={["to"]}
          className="form-item__to"
          label="ค้นหาถึงช่วงวันเวลา"
          rules={[{ required: true }]}
        >
          <DatePicker 
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item
          name={["stationId"]}
          className="form-item__station-id"
          label="สถานี"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" onChange={async(e)=>{
            let sensors = await MasterService.getMasterSensorByOrgIdAndStationId(e)
            if(sensors) setSelSensors(sensors)
          }}>
            <Option key={null} value={0}>ทั้งหมด</Option>
            {selStation.map((item) =>( <Option key={item.id} value={item.id}>{item.name_th}</Option>))}
          </Select>
        </Form.Item>
        <Form.Item
          name={["sensorId"]}
          className="form-item__sensor-id"
          label="เซนเซอร์"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก" onChange={async(e)=>{
            let parameters = await MasterService.getMasterParameterByOrgIdAndSensorId(e)
            if(parameters) setSelParameters(parameters)
          }}>
            <Option key={null} value={0}>ทั้งหมด</Option>
            {selSensors.map((item) =>( <Option key={item.id} value={item.id}>{item.disp_name}</Option>))}
          </Select>
        </Form.Item>
        <Form.Item
          name={["parameterId"]}
          className="form-item__parameter-id"
          label="พารามิเตอร์"
          rules={[{ required: true }]}
        >
          <Select placeholder="กรุณาเลือก">
            <Option key={null} value={0}>ทั้งหมด</Option>
            {selParameters.map((item) =>( <Option key={item.id} value={item.id}>{item.disp_name}</Option>))}
          </Select>
        </Form.Item>
        <Form.Item className="form-button">
          <Button
            className="form-item__btn-submit btn-primary btn-primary"
            htmlType="submit"
          >
            ค้นหา
          </Button>
        </Form.Item>
      </>
    );
  };

  return (
      <>
    <FormExtend
      name={"form-line-chart-option"}
      column={2}
      inputs={formInput}
      onFinish={props.onFinish ? props.onFinish : onFinish}
      form={form}
      className={props.className ? props.className : ""}
    />
    
    </>
  );
}
